/** SLA-határidő számítása (munkaidő nélkül; a munkaidős SLA az F2 része). */
export interface SlaBemenet { kezdetMs: number; slaPerc: number; nowMs: number }
export interface SlaAllapot {
  kesik: boolean;
  /** Előjeles: negatív, ha a határidő lejárt. */
  hatralevoPerc: number;
  /** Az eltelt idő a határidő arányában, 0–1. */
  eltelt: number;
  szoveg: string;
}

/** 74 → „1 óra 14 perc”, 60 → „1 óra”, 14 → „14 perc”. */
export function idoSzoveg(perc: number): string {
  const ora = Math.floor(perc / 60);
  const p = perc % 60;
  if (ora === 0) return `${p} perc`;
  return p === 0 ? `${ora} óra` : `${ora} óra ${p} perc`;
}

/** 12 → „12 perce”, 65 → „1 óra 5 perce”, 120 → „2 órája” (a „lejárt” szó elé). */
function lejartIdo(perc: number): string {
  const ora = Math.floor(perc / 60);
  const p = perc % 60;
  if (ora === 0) return `${p} perce`;
  return p === 0 ? `${ora} órája` : `${ora} óra ${p} perce`;
}

export function slaAllapot({ kezdetMs, slaPerc, nowMs }: SlaBemenet): SlaAllapot {
  if (!(slaPerc > 0)) throw new RangeError(`Érvénytelen SLA-határidő: ${slaPerc}`);
  const elteltPerc = (nowMs - kezdetMs) / 60_000;
  const hatralevo = slaPerc - elteltPerc;
  const eltelt = Math.min(1, Math.max(0, elteltPerc / slaPerc));
  if (hatralevo > 0) {
    const perc = Math.floor(hatralevo);
    return {
      kesik: false, hatralevoPerc: perc, eltelt,
      szoveg: perc < 1 ? 'kevesebb mint 1 perc van hátra' : `${idoSzoveg(perc)} van hátra`,
    };
  }
  const lejart = Math.floor(-hatralevo);
  return {
    kesik: true, hatralevoPerc: -lejart, eltelt: 1,
    szoveg: lejart < 1 ? 'most járt le' : `${lejartIdo(lejart)} lejárt`,
  };
}
